import { DeviceStatus } from '../types/device-status';

export type DeviceStatusVariant = 'default' | 'secondary' | 'destructive' | 'success';

export function getDeviceStatusVariant(status: DeviceStatus): DeviceStatusVariant {
  switch (status) {
    case DeviceStatus.ONLINE:
      return 'success';
    case DeviceStatus.OFFLINE:
      return 'destructive';
    case DeviceStatus.UNKNOWN:
      return 'secondary';
    default:
      return 'default';
  }
}

export function getDeviceStatusBorderClass(status: DeviceStatus): string {
  switch (status) {
    case DeviceStatus.ONLINE:
      return 'border-success-dark';
    case DeviceStatus.OFFLINE:
      return 'border-destructive-dark';
    case DeviceStatus.UNKNOWN:
      return 'border-black';
    default:
      return 'border-border';
  }
}

export function getDeviceStatusBackgroundClass(status: DeviceStatus): string {
  switch (status) {
    case DeviceStatus.ONLINE:
      return 'bg-success-light';
    case DeviceStatus.OFFLINE:
      return 'bg-destructive-light';
    case DeviceStatus.UNKNOWN:
      return 'bg-background-light';
    default:
      return 'bg-background-light';
  }
}
